import CookiesPage from 'components/pages/Cookies';

const Cookies = () => <CookiesPage />;

export default Cookies;
